/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */

import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// firebase/auth (~76 KB raw) is intentionally NOT imported here — calling
// getAuth(app) at module load would pull the auth SDK into main.js because
// src/index.js side-effect-imports this file at startup. Auth is only used
// by utils/firebase.js (consumed inside the lazy sagas chunk), so getAuth
// is invoked there instead. /inspection never loads the sagas chunk and
// therefore never pays for firebase/auth.

const env = window._env_.DEPLOYMENT_PROFILE;

const firebaseConfigDev = {
  apiKey: process.env.REACT_APP_DevFirebaseApiKey,
  authDomain: process.env.REACT_APP_DevAuthDomain,
  databaseURL: process.env.REACT_APP_DevDatabaseUrl,
  projectId: process.env.REACT_APP_DevProjectId,
  storageBucket: process.env.REACT_APP_DevStorageBucket,
  messagingSenderId: process.env.REACT_APP_DevMessagingSenderId,
  appId: process.env.REACT_APP_DevAppId,
  measurementId: process.env.REACT_APP_DevMeasurementId,
};

const firebaseConfigProd = {
  apiKey: process.env.REACT_APP_ProdFirebaseApiKey,
  authDomain: process.env.REACT_APP_ProdAuthDomain,
  databaseURL: process.env.REACT_APP_ProdDatabaseUrl,
  projectId: process.env.REACT_APP_ProdProjectId,
  storageBucket: process.env.REACT_APP_ProdStorageBucket,
  messagingSenderId: process.env.REACT_APP_ProdMessagingSenderId,
  appId: process.env.REACT_APP_ProdAppId,
  measurementId: process.env.REACT_APP_ProdMeasurementId,
};

const firebaseConfig = env === 'dev' || env === 'preDev' ? firebaseConfigDev : firebaseConfigProd;

const app = initializeApp(firebaseConfig);

const appCheckKey =
  env === 'dev' || env === 'preDev'
    ? process.env.REACT_APP_DevAppCheckSiteKey
    : process.env.REACT_APP_ProdAppCheckSiteKey;

// Debug token bypasses App Check attestation (used for e2e / non-profiled
// browsers). Value lives in gitignored .env.local; never define it in a
// production build environment.
if ((env === 'dev' || env === 'preDev') && process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
}

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(appCheckKey),

  // Optional arguement. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true,
});

export default app;
